import {
  type MobileIdPrepareSignatureMutationVariables,
  type MobileIdSignContractMutationVariables,
  useMobileIdPrepareSignatureMutation,
  useMobileIdSignContractMutation,
} from 'api/core/generated';
import { AppApiVersions } from 'app-constants';

export const useSignContractWithMobileId = () => {
  const [prepareForMobileIdSigning, { data, loading, error }] =
    useMobileIdPrepareSignatureMutation({
      context: { apiVersion: AppApiVersions.core },
    });

  const [
    signMobileIdContract,
    { data: mobileIdSignatureData, error: mobileIdSignatureError },
  ] = useMobileIdSignContractMutation();

  const prepareMobileIdContractSignature = (
    variables: MobileIdPrepareSignatureMutationVariables,
  ) => prepareForMobileIdSigning({ variables });

  const signContractWithMobileId = (
    variables: MobileIdSignContractMutationVariables = {},
  ) =>
    signMobileIdContract({
      variables,
      context: {
        apiVersion: AppApiVersions.core,
      },
    });

  return {
    mobileIdContractSignaturePreparationLoading: loading,
    mobileIdContractSignaturePreparationChallenge: data?.challenge ?? null,
    mobileIdContractSignaturePreparationError: error,
    signContractWithMobileIdSuccess: mobileIdSignatureData?.success,
    signContractWithMobileIdError: mobileIdSignatureError,
    prepareMobileIdContractSignature,
    signContractWithMobileId,
  };
};
